var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _ellipse, _circle, _ellipse2, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateNoEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.156 80.0632C123.087 80.2761 122.889 80.4202 122.665 80.4202H102.108C101.607 80.4202 101.399 81.0607 101.804 81.3549L118.435 93.4381C118.616 93.5697 118.692 93.8029 118.623 94.0158L112.27 113.567C112.116 114.043 112.66 114.439 113.065 114.145L129.696 102.061C129.878 101.93 130.123 101.93 130.304 102.061L146.935 114.145C147.34 114.439 147.885 114.043 147.73 113.567L141.378 94.0158C141.308 93.8029 141.384 93.5697 141.565 93.4381L158.196 81.3549C158.601 81.0607 158.393 80.4202 157.893 80.4202H137.335C137.112 80.4202 136.913 80.2761 136.844 80.0632L130.492 60.512C130.337 60.036 129.663 60.036 129.509 60.512L123.156 80.0632ZM130 83.7164C128.804 86.0202 126.585 87.632 124.024 88.0581C125.846 89.908 126.693 92.5159 126.307 95.083C128.629 93.9225 131.371 93.9225 133.693 95.083C133.307 92.5159 134.155 89.908 135.976 88.0581C133.415 87.632 131.197 86.0202 130 83.7164Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.842 91.512C170.997 91.036 171.67 91.036 171.825 91.512L175.857 103.923C175.927 104.136 176.125 104.28 176.349 104.28H189.399C189.899 104.28 190.107 104.921 189.702 105.215L179.145 112.885C178.964 113.017 178.888 113.25 178.957 113.463L182.99 125.874C183.144 126.35 182.6 126.746 182.195 126.451L171.637 118.781C171.456 118.649 171.211 118.649 171.03 118.781L160.472 126.451C160.067 126.746 159.523 126.35 159.677 125.874L163.71 113.463C163.779 113.25 163.703 113.017 163.522 112.885L152.965 105.215C152.56 104.921 152.768 104.28 153.268 104.28H166.318C166.542 104.28 166.74 104.136 166.81 103.923L170.842 91.512Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1754 91.512C88.3301 91.036 89.0035 91.036 89.1582 91.512L93.1908 103.923C93.2599 104.136 93.4583 104.28 93.6821 104.28H106.732C107.232 104.28 107.44 104.921 107.036 105.215L96.4781 112.885C96.297 113.017 96.2212 113.25 96.2904 113.463L100.323 125.874C100.478 126.35 99.9328 126.746 99.5279 126.451L88.9705 118.781C88.7894 118.649 88.5442 118.649 88.3631 118.781L77.8057 126.451C77.4008 126.746 76.8559 126.35 77.0106 125.874L81.0432 113.463C81.1124 113.25 81.0366 113.017 80.8555 112.885L70.2981 105.215C69.8932 104.921 70.1013 104.28 70.6018 104.28H83.6515C83.8753 104.28 84.0737 104.136 84.1428 103.923L88.1754 91.512Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 111.958C132.14 111.958 133.875 113.693 133.875 115.833V177.833C133.875 179.973 132.14 181.708 130 181.708C127.86 181.708 126.125 179.973 126.125 177.833V115.833C126.125 113.693 127.86 111.958 130 111.958Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.5 140.375C164.373 140.375 154.542 150.206 154.542 162.333V170.083C154.542 172.223 152.807 173.958 150.667 173.958C148.527 173.958 146.792 172.223 146.792 170.083V162.333C146.792 145.926 160.093 132.625 176.5 132.625H179.083C181.224 132.625 182.958 134.36 182.958 136.5C182.958 138.64 181.224 140.375 179.083 140.375H176.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5001 140.375C95.6274 140.375 105.458 150.206 105.458 162.333V170.083C105.458 172.223 107.193 173.958 109.333 173.958C111.474 173.958 113.208 172.223 113.208 170.083V162.333C113.208 145.926 99.9076 132.625 83.5001 132.625H80.9168C78.7767 132.625 77.0418 134.36 77.0418 136.5C77.0418 138.64 78.7767 140.375 80.9168 140.375H83.5001Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8335 159.75C93.8335 164.03 90.3637 167.5 86.0835 167.5C81.8033 167.5 78.3335 164.03 78.3335 159.75C78.3335 155.47 81.8033 152 86.0835 152C90.3637 152 93.8335 155.47 93.8335 159.75Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.667 159.75C181.667 164.03 178.197 167.5 173.917 167.5C169.637 167.5 166.167 164.03 166.167 159.75C166.167 155.47 169.637 152 173.917 152C178.197 152 181.667 155.47 181.667 159.75Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5002 51.4998C120 38 140.989 51.4997 154 60.9998C185.5 83.9999 178.179 157.5 167.5 183.5C156 211.5 128.5 224 93.0002 210.5C63.1887 199.163 43.5003 173.631 43.5002 134.5C43.5002 93.4998 66.173 62.6325 90.5002 51.4998Z",
    fill: "url(#paint0_linear_27928_144970)",
    fillOpacity: 0.07
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 135.5C157.496 131.391 115 86 158.5 69C202 52 228 138 192.5 180C157 222 95.7464 201.5 76.0002 174.5C51.5002 141 91 140.5 127.5 135.5Z",
    fill: "url(#paint1_linear_27928_144970)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.082,
    cy: 38.4229,
    rx: 8.352,
    ry: 10.0224,
    transform: "rotate(90.4069 140.082 38.4229)",
    fill: "url(#paint2_linear_27928_144970)",
    fillOpacity: 0.07
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 182,
    r: 5,
    fill: "url(#paint3_linear_27928_144970)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.9932,
    cy: 123.262,
    rx: 13.9929,
    ry: 19.59,
    transform: "rotate(20.6101 43.9932 123.262)",
    fill: "url(#paint4_linear_27928_144970)",
    fillOpacity: 0.15
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.533,
    cy: 173.581,
    rx: 6.77369,
    ry: 9.48316,
    transform: "rotate(29.1284 210.533 173.581)",
    fill: "url(#paint5_linear_27928_144970)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27928_144970",
    x1: 105.334,
    y1: 206.945,
    x2: 13.0018,
    y2: 68.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27928_144970",
    x1: 204.452,
    y1: 124.403,
    x2: 110.011,
    y2: 238.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27928_144970",
    x1: 139.487,
    y1: 47.3837,
    x2: 128.888,
    y2: 30.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27928_144970",
    x1: 225.644,
    y1: 186.47,
    x2: 220.823,
    y2: 177.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27928_144970",
    x1: 42.9964,
    y1: 140.777,
    x2: 21.0543,
    y2: 110.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27928_144970",
    x1: 210.051,
    y1: 182.059,
    x2: 199.429,
    y2: 167.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoEvents);
export default __webpack_public_path__ + "static/media/emptyStateNoEvents.a3289100.svg";
export { ForwardRef as ReactComponent };